import { AutogenModelRoutingGuideProfile, AutogenRowRoutingGuideProfile } from "./autogen/AutogenModelRoutingGuideProfile";

export class ModelRoutingGuideProfile extends AutogenModelRoutingGuideProfile<RowRoutingGuideProfile> {
    constructor() {
        super(RowRoutingGuideProfile);
    }
}

export class RowRoutingGuideProfile extends AutogenRowRoutingGuideProfile {
}